import { set } from 'react-global-configuration';
// store/useTableStore.ts
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { IFilter } from "../model/CommonModel";
import { TripDirection } from "../components/TripPlanComponent/TripPlanTableNew";

interface TableState {
  bookingTable: TableConfig;
  operationTable: TableConfig;
  dispatchTable: TableConfig;
  tripPlanTable: TableConfig;
  driverDashboardTable: TableConfig;
  VehicleDashboardTable: TableConfig;
  adhocTripDashboardTable: TableConfig;
  orderSequenceFilter: TableConfig;
  setBookingTableState: (data: Partial<TableConfig>) => void;
  setOperationTableState: (data: Partial<TableConfig>) => void;
  setDispatchWorkstationTableState: (data: Partial<TableConfig>) => void;
  setTripPlanTableState: (data: Partial<TableConfig>) => void;
  setDriverDashboardTableState: (data: Partial<TableConfig>) => void;
  setVehicleDashboardTableState: (data: Partial<TableConfig>) => void;
  setAdhocTripDashboardTableState: (data: Partial<TableConfig>) => void;
  setOrderSequenceFilterState: (data: Partial<TableConfig>) => void;
  clearAll: () => void;
}

interface TableConfig {
    filter: Partial<IFilter> | null;
    pageNumber: number;
    pageSize: number;
}

const defaultTableState = (filter: Partial<IFilter> | null = null): TableConfig => ({
    filter,
    pageNumber: 1,
    pageSize: 20,
});

export const useTableStore = create<TableState>()(
    persist(
        (set) => ({
            bookingTable: defaultTableState({}),
            operationTable: defaultTableState(),
            dispatchTable: defaultTableState(null),
            tripPlanTable: defaultTableState({ tripDirection: TripDirection.Outgoing }),
            driverDashboardTable: defaultTableState(),
            VehicleDashboardTable: defaultTableState(),
            adhocTripDashboardTable: defaultTableState(),
            orderSequenceFilter: defaultTableState(),
            setBookingTableState: (data) =>
                set((state) => ({
                    bookingTable: {
                        ...state.bookingTable,
                        ...data,
                    },
                })),
            setOperationTableState: (data) =>
                set((state) => ({
                    operationTable: {
                        ...state.operationTable,
                        ...data,
                    },
                })),
            setDispatchWorkstationTableState: (data) =>
                set((state) => ({
                    dispatchTable: {
                        ...state.dispatchTable,
                        ...data,
                    },
                })),
            setTripPlanTableState: (data) =>
                set((state) => ({
                    tripPlanTable: {
                        ...state.tripPlanTable,
                        ...data,
                    },
                })),
            setDriverDashboardTableState: (data) =>
                set((state) => ({
                    driverDashboardTable: {
                        ...state.driverDashboardTable,
                        ...data,
                    },
                })),
            setVehicleDashboardTableState: (data) => {
                return set((state) => ({
                    VehicleDashboardTable: {
                        ...state.VehicleDashboardTable,
                        ...data,
                    },
                }))
            },

            setAdhocTripDashboardTableState: (data) => {
                return set((state) => ({
                    adhocTripDashboardTable: {
                        ...state.adhocTripDashboardTable,
                        ...data,
                    },
                }))
            },
            setOrderSequenceFilterState: (data) =>
                set((state) => ({
                    orderSequenceFilter: {
                        ...state.orderSequenceFilter,
                        ...data,
                    },
                })),
            clearAll: () =>
                set(() => ({
                    bookingTable: defaultTableState({}),
                    operationTable: defaultTableState(),
                    dispatchTable: defaultTableState(null),
                    tripPlanTable: defaultTableState({ tripDirection: TripDirection.Outgoing }),
                    driverDashboardTable: defaultTableState(),
                    VehicleDashboardTable: defaultTableState(),
                    adhocTripDashboardTable: defaultTableState(),
                    orderSequenceFilter: defaultTableState(),
                })),
        }),
        {
            name: "table-filter-storage",
            storage: createJSONStorage(() => sessionStorage),
        }
    )
);
